<template>
  <ListSkeleton :count="count" class="skeleton-contents">
    <div :class="columnClass">
      <div class="student referer student-skeleton">
        <el-skeleton-item variant="circle" class="skeleton-avatar" />
        <div class="name skeleton-text">
          <SkeletonCell />
        </div>
      </div>
    </div>
  </ListSkeleton>
</template>

<script setup>
import ListSkeleton from '@/components/Global/ListSkeleton';
import SkeletonCell from '@/components/Global/SkeletonCell';

defineOptions({ name: 'JobStudentSkeleton' });

defineProps({
  count: {
    type: Number,
    default: 1,
  },
  columnClass: {
    type: String,
    default: 'col-sm-12',
  },
});
</script>
